import * as React from 'react'
// components
import { ReduxInput } from 'components/FormElements'
// views
import { AddButton } from 'components/Modals/PropertyDetailsModal/components/Form/view'
import { TrashIcon } from 'components/PageComponents/Settings/ObjectsAndProperties/Edit/Properties/components/Property/view'
import { RemoveButton, Row, Wrapper, Label } from './views'
// types
import { WrappedFieldArrayProps } from 'redux-form/lib/FieldArray'

interface Props {
  label?: string
}

const AiSuggestedPrompts: React.FC<WrappedFieldArrayProps<string> & Props> = ({ fields, label = 'Template Prompts' }) => {
  const removeField = (idx: number) => () => fields.remove(idx)

  const addField = () => fields.push('')

  return (
    <Wrapper>
      <Label>{label}</Label>
      {fields.map((prompt, index) => (
        <Row key={index}>
          <ReduxInput multiline name={prompt} placeholder='Enter prompt' />
          <RemoveButton onClick={removeField(index)}>
            <TrashIcon />
          </RemoveButton>
        </Row>
      ))}
      <AddButton onClick={addField}>+ add prompt</AddButton>
    </Wrapper>
  )
}

export default AiSuggestedPrompts
